import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication.service";
import {
  Http,
  Headers,
  RequestOptions,
  Response,
  URLSearchParams
} from "@angular/http";

@Injectable()
export class CaTransService {

  constructor(private auth: AuthenticationService, private http: Http) { }

  Get_BillRciept(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_BillRciept",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_UnpaidSales(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Load_UnpaidSales",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveBillReciept(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_BillReciept",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  updateBillReciept(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_BillReciept",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getBillRecieptById(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_BillRecieptById",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  deleteBillReceipt(Id: any) {
    if (Id != 0) {
      return this.http
        .get(
          this.auth.baseUrl + "/services/api/v1/Delete_BillReceipt?Id=" + Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  /// PDC Psting ////

  GetPDCPaybleList(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PDCPaybleList",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SavePDCPayblePost(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/SavePDCPayblePost",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetPDCRecivebleList(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PDCRecivableList",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  /// PDC Psting ////


  ///Bank Reconciliation ///
  GetLedgerReconciliation(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Ledger_Reconciliation",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetBankReconciliation(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Bank_Reconciliation",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveBankReconciliation(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_Bank_Reconciliation",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_Ledger_Reconciliation(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_Ledger_Reconciliation",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  ///Bank Reconciliation ///

  ///AC_Cash Collection ///
  GetPOSCashCollection(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LoadPOSCashCollection",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  PostPOSCashCollection(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_POSCashCollection",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetPOSCashCollectionById(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_POSCashCollectionById",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  UpdatePOSCashCollection(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_POSCashCollection",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  DeletePOSCashCollection(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_POSCashCollection",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  GetPOSCashCollectionDetails(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_POSCashCollectionDetails",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  ///AC_Cash Collection///
  // ---------------PDC PAyment/Receipt//
  SavePDCPaymentReceipt(FilterItems: any) {
    if (FilterItems.PDCTransNo == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_PDCReceipt",
          FilterItems,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
    else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_PDCReceipt",
          FilterItems,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  getPDCPaymentReceipt(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Pdc",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getPdcByTransNo(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_PdcByTransNo",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  deletePDCPaymentReceipt(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_PDCPaymentReceipt",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Unpost_PDC(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/UnPost_PDC",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  SavePDCInterBranchPaymentReceipt(FilterItems: any) {
    if (FilterItems.PDCTransNo == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_PDCInterBranch",
          FilterItems,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
    else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_PDCInterBranch",
          FilterItems,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deletePDCInterbranchPaymentReceipt(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_PdcInterBranch",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // ---------------PDC PAyment/Receipt//
  //--------------InterBranch Transaction-----------------//
  Save_InterBranchTransaction(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_InterBranchTransaction",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_InterBranchTransaction(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_InterBranchTransaction",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_InterBranchTransaction(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_InterBranchTransaction",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_InterBranchTransactionList(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_InterBranchTransactionList",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_InterBranchTransactionById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_InterBranchTransactionById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Save_InterBranchTransactionMultiple(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_InterBranchTransactionMultiple",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_InterBranchTransactionMultiple(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_InterBranchTransactionMultiple",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_InterBranchTransactionByIdMultiple(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_InterBranchTransactionByIdMultiple",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Generate_InterBranchVoucherNo(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Generate_InterBranchVoucherNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------InterBranch Transaction-----------------//
  //--------------Recurring Transaction-----------------//
  Get_RecurringTransaction(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_RecurringTransaction",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RecurringTransactionById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_RecurringTransactionById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_RecurringTransaction(Body: any) {
    if (Body.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_RecurringTransaction",
          Body,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
    else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_RecurringTransaction",
          Body,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  Delete_RecurringTransaction(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_RecurringTransaction",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------Recurring Transaction-----------------//
  //---------------Inter branch account posting-----------------//
  Get_InterBranchAccountPostingList(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_InterBranchAccountPostingList",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Post_InterBranchAccounts(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Post_InterBranchAccounts",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------Inter branch account posting-----------------//

  //--------------Trasfer Posting------------------------------//
  Get_TransferForPosting(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_TransferForPosting",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Save_TransferPosting(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_TransferPosting",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------Transfer Posting-----------------------------//
  //--------------Purchase Posting-----------------------------//
  Get_DataForPosting(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DataForPosting",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Save_InvPosting(Body: any){
    return this.http
    .post(
      this.auth.baseUrl + "/services/api/v1/Save_InvPosting",
      Body,
      this.auth.getHeader()
    )
    .map(res => {
      return res.json();
    });
  }
  //---------------Purchase Posting------------------------------//
  //---------------Advance cash collection------------------------------//
  Get_CustomerListForAdvanceCashCollection() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_CustomerListForAdvanceCashCollection",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_AdvanceCashCollectionList(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_AdvanceCashCollectionList",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_BalanceForAdvanceCashCollection(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_BalanceForAdvanceCashCollection",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_AdCashCollection(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_AdCashCollection",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_AdCashCollectionById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_AdCashCollectionById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_AdCashCollectionPromotion(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_AdCashCollectionPromotion",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------Advance cash collection------------------------------//
  //-----------------pdc unpost----------------------------------//
  Get_UnpostPdcPosting(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_UnpostPdcPosting",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Pdc_Unpost(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Pdc_Unpost",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //-----------------pdc unpost----------------------------------//
  //------------------Perfomance Rpt-----------------------------//
  Get_DataForPerformanceReport(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DataForPerformanceReport",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //------------------Perfomance Rpt-----------------------------//
   //------------------Cheque Issue-----------------------------//
   Get_ChequeIssueList(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ChequeIssueList",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  
  Update_ChequeIssue(model:any){
    return this.http
    .post(
      this.auth.baseUrl + "/services/api/v1/Update_ChequeIssue",
      model,
      this.auth.getHeader()
    )
    .map(res => {
      return res.json();
    });
  }
   //------------------Cheque Issue-----------------------------//
   
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/accounts/ca-trans.service.ts